export const css = {
	root: 'OgoKrlLJ',
	' _key': 'ascm-theme/ascm/variants/cltd2024'
};

export default css;
